module.exports = __webpack_public_path__ + "img/line-icon.0d9774d4.svg";